/**
 * Ambient context for reporters that cannot use React hooks.
 *
 * Most of what an incident needs is already on every Faro event: build version
 * and environment come from `app`, the route from `setView`, user and vendor
 * from `setUser`, connectivity from `instrumentDevice`. What is missing is the
 * handful of values that only a mounted component knows — the antd breakpoint
 * and whether geolocation is actually working on this device.
 *
 * A component keeps this fresh (see `AppContent`); plain modules read it when
 * they report. Deliberately tiny: anything that belongs on *every* event should
 * go on the Faro session instead of being copied per report.
 */

export interface DeviceContext {
	/** antd breakpoint label — xxs … xxl. */
	screenSize?: string;
	isGeolocationEnabled?: boolean;
	isGeolocationAvailable?: boolean;
}

let current: DeviceContext = {};

export function setDeviceContext(next: DeviceContext): void {
	current = next;
}

export function getDeviceContext(): DeviceContext {
	return current;
}
